<template>
  <div class="opera-setting">
    <topNav :title="$t('setting_title')"
            url='/opera/center' replace="true"></topNav>
    <mt-cell :title="$t('setting_account_security')"
             to="/opera/account" is-link class="split topcell" style="margin-top:0.4rem"></mt-cell>

    <mt-cell :title="$t('setting_message_notice')"
             to="/opera/messagePush?redirect=/opera/setting" is-link class="topcell"></mt-cell>
    <mt-cell :title="$t('settinge_device')"
             to="/opera/device" is-link></mt-cell>

    <a class="mint-cell split">
      <div class="mint-cell-left"></div>
      <div class="mint-cell-wrapper" @click="clearCache">
        <div class="mint-cell-title">
          <span class="mint-cell-text">
            {{$t('setting_clean_localStorage')}}
          </span>
        </div>
        <i class="mint-cell-allow-right"></i>
      </div>
      <div class="mint-cell-right"></div>
    </a>

    <mt-cell :title="$t('setting_sys_option')"
             style="margin-top:0.4rem"
             to="/opera/sysOption/sysOptionList"
             v-if="perInfo.code=='ADMIN'"
             is-link></mt-cell>
  </div>
</template>
<script>
  import {Toast, MessageBox} from "mint-ui";

  export default {
    data() {
      return {
        perInfo: {}
      };
    },
    mounted() {
      this.$http.get("/mobilepmsapi/sys/getUserInfo").then(res => {
        if (res.data.result == 0) {
          this.perInfo = res.data.retVal;
        }
      });
    },
    methods: {
      clearCache() {
        MessageBox.confirm(this.$t("device_message"))
          .then(action => {
            if (action == "confirm") {
              localStorage.clear();
              Toast({
                message: this.$t("success"),
                position: "bottom",
                duration: 3000
              });
              if (window.navigator.userAgent.indexOf("Html5Plus") > 0) {
                plus.storage.clear();
                var A = plus.webview.getLaunchWebview();
                A.evalJS("loginOut(false)");
                return;
              }
              location.reload();
            }
          })
          .catch(action => {
          });
      }
    },
    filters: {
      dateF(value) {
        if (value == null || value == "") {
          return "";
        }
        return value.substring(0, 10);
      }
    },
    components: {}
  };
</script>
<style lang='less'>
  .opera-setting {
    background-color: #f7f8fa;

    .split {
      background-image: linear-gradient(0deg, #d9d9d9, #d9d9d9 50%, transparent 50%);
      background-size: 100% 1px;
      background-repeat: no-repeat;
      background-position: bottom;
      margin-bottom: 0.8rem;
    }

    .topcell {
      .mint-cell-wrapper {
        background-origin: border-box;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// setting.vue?1e40aea5